export default "<p>timetable works!</p>\n";